import utils from './utils'
import accordion from './js-accordion'
import search from './search'
import risultati from './risultati-ricerca'
import navigation from './navigation'
import slider from './slider'
import convenzioni from './convenzioni'
import widgetConto from './widgetConto'
import widgetMutuo from './widgetMutuo'
import widgetCarta from './widgetCarta'
import calcoloRata from './calcola-rata-mutuo'
import correlati from './correlati'
import filiali from './filiali'
import popup from './popup'

utils();
accordion();
search();
risultati();
navigation();
slider();
convenzioni();
widgetConto();
widgetMutuo();
widgetCarta();
calcoloRata();
correlati();
filiali();
popup();